export const PROJECT_TYPE_COLORS = Object.freeze({
  DATAROOM: '#F6F2FF',
  PROJECT: '#EDF4F9',
  ELECTRONIC_SAFE: '#F2F5FF',
})
